import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchAdvancedEmailTemplateById } from 'api/engage';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';

interface AdvancedMessageTemplatePreviewProps {
    templateId: string;
}

const EmailMessageTemplatePreview = ({ templateId }: AdvancedMessageTemplatePreviewProps) => {
    const { accountId } = useCurrentAccount();

    const { data: template } = useSuspenseQuery({
        queryKey: accountQueryKeys.engageAdvancedMessageTemplateById(accountId, templateId),
        queryFn: () => fetchAdvancedEmailTemplateById(templateId),
    });

    return (
        <div className="flex flex-col">
            <div className="flex flex-col gap-1 p-6">
                <p className="font-medium">{template.title}</p>
            </div>
            <div className="flex flex-col items-center p-6">
                <img
                    alt={`${template.title} Template Preview`}
                    src={template.thumbnail_large}
                    className="max-w-4xl"
                />
            </div>
        </div>
    );
};

export { EmailMessageTemplatePreview };
